import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
  DialogText,
  ActionBar,
  CancelButton,
  Dialog
} from 'src/components/Dialog'
import { breakpoint } from 'src/theme/grid'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'
import {
  INVOICE_NUMBERING_SCHEME,
  INVOICE_NUMBERING_SCHEME_OPTIONS
} from 'src/features/invoices/duck/consts'
import TextInput from 'src/components/atoms/TextInput'
import { SaveOfferButton } from 'src/components/atoms/Buttons'

export const InvoiceSettingsDialog = ({
  onClose,
  renderNumberingSchemeOption,
  open,
  onClick,
  paymentBankAccount,
  issuePlace,
  paymentBankName,
  numberingScheme,
  onChange,
  showMyCompanyInvoiceSettings
}) => {
  const intl = useIntl()

  useEffect(() => {
    showMyCompanyInvoiceSettings()
  }, [])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={<FormattedMessage id='invoices.settingsTitle' />}
      PaperProps={{ style: { borderRadius: 9 } }}
    >
      <DialogText>
        <FormattedMessage id='invoices.settingsDescription' />
      </DialogText>
      <InputTitle>
        <FormattedMessage id='invoices.numberingScheme' />
      </InputTitle>
      <RadioWrapper>
        {INVOICE_NUMBERING_SCHEME_OPTIONS.map(renderNumberingSchemeOption)}
      </RadioWrapper>
      <Description>
        {numberingScheme === INVOICE_NUMBERING_SCHEME.MONTHLY && (
          <FormattedMessage id='invoices.monthlyDescription' />
        )}
        {numberingScheme === INVOICE_NUMBERING_SCHEME.YEARLY && (
          <FormattedMessage id='invoices.yearlyDescription' />
        )}
      </Description>
      <InputsRow>
        <BankAccount>
          <TextInput
            type='text'
            label={intl.formatMessage({
              id: 'invoices.bankAccount'
            })}
            id='bankAccount'
            name='paymentBankAccount'
            placeholder=''
            value={paymentBankAccount}
            onChange={onChange}
          />
        </BankAccount>
        <BankName>
          <TextInput
            type='text'
            label={intl.formatMessage({
              id: 'invoices.bankName'
            })}
            id='bankName'
            name='paymentBankName'
            placeholder=''
            value={paymentBankName}
            onChange={onChange}
          />
        </BankName>
      </InputsRow>
      <InputsRow>
        <IssuePlace>
          <TextInput
            type='text'
            label={intl.formatMessage({
              id: 'invoices.issuePlace'
            })}
            id='issuePlace'
            name='issuePlace'
            placeholder=''
            value={issuePlace}
            onChange={onChange}
          />
        </IssuePlace>
        <BankName />
      </InputsRow>
      <ActionBar>
        <CancelButton onClick={onClose}>
          {intl.formatMessage({ id: 'myOffers.notNow' })}
        </CancelButton>
        <SaveOfferButton active onClick={onClick}>
          <FormattedMessage id='invoices.configData' />
        </SaveOfferButton>
      </ActionBar>
    </Dialog>
  )
}

export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`
const InputsRow = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint.m`
    flex-wrap: wrap;
    flex-direction: row;
      & > div:not(:last-child) {
    margin-right: 0.5rem;
  }
    `}
`
const Description = styled.div`
  opacity: 0.7;
  font-size: 0.75rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.black.hex()};
  margin-bottom: 1rem;
`
export const InputTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black.hex()};
  margin-bottom: 0.3rem;
  margin-left: 0.2rem;
  ${({ required }) =>
    required &&
    `
    &:after {
      content: '*';
      color: red;
      font-size: 0.75rem;
    }
  `}
`
const BankAccount = styled.div`
  flex: 1;
`
const BankName = styled.div`
  flex: 0.6;
`
const IssuePlace = styled.div`
  flex: 1;
`
